export const reservationAgreementEn = `
<html>
<head>
    <meta content="text/html; charset=UTF-8" http-equiv="content-type">
    <style>ol {
        margin: 0;
        padding: 0
    }

    table td, table th {
        padding: 0
    }

    .c1 {
        color: #000000;
        font-weight: 700;
        text-decoration: none;
        vertical-align: baseline;
        font-size: 13pt;
        font-family: "Arial";
        font-style: normal
    }

    .c0 {
        padding-top: 0pt;
        padding-bottom: 0pt;
        line-height: 1.15;
        orphans: 2;
        widows: 2;
        text-align: left;
        height: 11pt
    }

    .c3 {
        color: #000000;
        font-weight: 400;
        text-decoration: none;
        vertical-align: baseline;
        font-size: 11pt;
        font-family: "Arial";
        font-style: normal
    }

    .c6 {
        padding-top: 14pt;
        padding-bottom: 4pt;
        line-height: 1.15;
        orphans: 2;
        widows: 2;
        text-align: left
    }

    .c9 {
        padding-top: 0pt;
        padding-bottom: 0pt;
        line-height: 1.15;
        orphans: 2;
        widows: 2;
        text-align: left
    }

    .c7 {
        color: #1155cc;
        text-decoration: underline;
        vertical-align: baseline;
        font-size: 11pt;
        font-style: normal
    }

    .c2 {
        padding-top: 12pt;
        padding-bottom: 12pt;
        line-height: 1.15;
        orphans: 2;
        widows: 2;
        text-align: left
    }

    .c8 {
        background-color: #ffffff;
        max-width: 468pt;
        padding: 72pt 72pt 72pt 72pt
    }

    .c10 {
        color: #000000;
        font-weight: 400;
        text-decoration: none;
        vertical-align: baseline;
        font-size: 20pt;
        font-family: "Arial";
        font-style: normal;
    }

    .c4 {
        font-weight: 700
    }

    .title {
        padding-top: 0pt;
        color: #000000;
        font-size: 26pt;
        padding-bottom: 3pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left
    }

    .subtitle {
        padding-top: 0pt;
        color: #666666;
        font-size: 15pt;
        padding-bottom: 16pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left
    }

    li {
        color: #000000;
        font-size: 11pt;
        font-family: "Arial"
    }

    p {
        margin: 0;
        color: #000000;
        font-size: 11pt;
        font-family: "Arial"
    }

    h1 {
        padding-top: 20pt;
        color: #000000;
        font-size: 20pt;
        padding-bottom: 6pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left;
    }

    h2 {
        padding-top: 18pt;
        color: #000000;
        font-size: 16pt;
        padding-bottom: 6pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left
    }

    h3 {
        padding-top: 16pt;
        color: #434343;
        font-size: 14pt;
        padding-bottom: 4pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left
    }

    h4 {
        padding-top: 14pt;
        color: #666666;
        font-size: 12pt;
        padding-bottom: 4pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left
    }

    h5 {
        padding-top: 12pt;
        color: #666666;
        font-size: 11pt;
        padding-bottom: 4pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left
    }

    h6 {
        padding-top: 12pt;
        color: #666666;
        font-size: 11pt;
        padding-bottom: 4pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        font-style: italic;
        orphans: 2;
        widows: 2;
        text-align: left
    }</style>
</head>
<body class="c8 doc-content">

<h1><span class="c10">Reservation Agreement</span></h1>

<p class="c0"><span class="c2"></span></p>
<p class="c5"><span class="c2">Last updated: 2025-04-16</span></p>
    
<p class="c0"><span class="c3"></span></p>
<p class="c2"><span>This Reservation Agreement (&ldquo;Agreement&rdquo;) governs the placing of a reservation (&ldquo;Reservation&rdquo;) with </span><span
        class="c4">PakVille Construction Corp.</span><span class="c3">, 618, av. Meloche, Dorval, Quebec, Canada (&ldquo;PakVille&rdquo;) for a future PakVille home (&ldquo;PakVille Home&rdquo;). Please carefully read this Agreement before submitting your Reservation. By submitting your Reservation, you agree to be legally bound by all terms of this Agreement.</span>
</p>
<hr>
<p class="c0"><span class="c3"></span></p>
<h3 class="c6" id="h.v8du15wmlfql"><span class="c1">1. Reservation Agreement</span></h3>
<p class="c2"><span>By entering into this Agreement and paying the Reservation Fee, you are reserving the opportunity to purchase a future PakVille Home. This Agreement does </span><span
        class="c4">not</span><span>&nbsp;obligate you to purchase a PakVille Home, and it does </span><span class="c4">not</span><span
        class="c3">&nbsp;obligate PakVille to sell you a PakVille Home. This is not a sales, lease, or construction contract for a specific unit and does not secure a production or delivery date, guaranteed pricing, or exact design specifications.</span>
</p>
<p class="c2"><span>Once homes become available for configuration and allocation, PakVille will invite you to finalize your configuration. You will then receive an estimate of pricing and available options. To proceed with a purchase, you will be required to sign a separate </span><span
        class="c4">Final Sales Agreement</span><span class="c3">, which will contain all binding terms, including final pricing and applicable taxes and fees.</span>
</p>
<p class="c2"><span class="c3">By making a Reservation, you confirm that you are at least 18 years old or the age of majority in your province/territory and have legal capacity to enter into this Agreement. If you are reserving on behalf of a company or organization, you confirm you have authority to bind that entity to this Agreement. PakVille reserves the right to accept or reject Reservations at its sole discretion.</span>
</p>
<hr>
<p class="c0"><span class="c3"></span></p>
<h3 class="c6" id="h.l70ce7fg876y"><span class="c1">2. Reservation Fee</span></h3>
<p class="c2"><span>You will be charged a one-time Reservation Fee of </span><span class="c4">CAD $150</span><span>&nbsp;when placing your Reservation. This fee is </span><span
        class="c4">not</span><span>&nbsp;a deposit or installment toward the purchase of a PakVille Home and does </span><span
        class="c4">not</span><span class="c3">&nbsp;guarantee allocation or delivery of a home.</span></p>
<p class="c2"><span>You may cancel your Reservation at any time and receive a </span><span class="c4">full refund</span><span>&nbsp;of the Reservation Fee by emailing</span><span
        class="c4">&nbsp;<a class="c7" href="mailto:info@pakville.ca">info@pakville.ca</a></span><span class="c3">&nbsp;from the same email address used to make your Reservation.</span>
</p>
<p class="c2"><span class="c3">If you proceed to execute a Final Sales Agreement and take possession of a PakVille Home, the Reservation Fee will be credited toward your final purchase price.</span>
</p>
<hr>
<p class="c0"><span class="c3"></span></p>
<h3 class="c6" id="h.q04vvls2yvdy"><span class="c1">3. Preliminary Price Estimate</span></h3>
<p class="c2"><span>Any pricing provided before the execution of a Final Sales Agreement is a </span><span class="c4">Preliminary Price Estimate</span><span
        class="c3">&nbsp;only. It is non-binding and does not constitute an offer or commitment by PakVille.</span></p>
<p class="c2"><span class="c3">The Preliminary Price Estimate may exclude applicable taxes, documentation fees, delivery costs, and other charges. Final pricing will depend on your selected configuration, delivery method, and any adjustments in materials, design, or construction costs that occur prior to contract signing.</span>
</p>
<hr>
<p class="c0"><span class="c3"></span></p>
<h3 class="c6" id="h.jx86ojp1pe2w"><span class="c1">4. Delivery</span></h3>
<p class="c2"><span class="c3">Priority for delivery is influenced by the date of your Reservation Fee payment. Actual delivery is subject to home availability, construction timelines, configuration completion, and signing of the Final Sales Agreement.</span>
</p>
<p class="c2"><span class="c3">PakVille does not guarantee specific delivery dates and is not liable for delays caused by permitting, construction, supply chain issues, weather, or other unforeseen conditions.</span>
</p>
<hr>
<p class="c0"><span class="c3"></span></p>
<h3 class="c6" id="h.7o93c16t7rns"><span class="c1">5. Privacy Policy and Terms of Use</span></h3>
<p class="c2"><span>All personal information you submit will be handled according to our </span><a class="c7" href="/privacy-policy">Privacy Policy</a><span>&nbsp;and </span><a class="c7" href="/terms-of-service">Terms of Service</a><span class="c3">. Please review these documents for details on how your data will be used and protected.</span>
</p>
<hr>
<p class="c0"><span class="c3"></span></p>
<h3 class="c6" id="h.h1weohwgindl"><span class="c1">6. Limitation of Liability</span></h3>
<p class="c2"><span>To the fullest extent permitted by law, PakVille will not be liable for any indirect, incidental, special, or consequential damages related to this Agreement or your Reservation. Your sole and exclusive remedy is a </span><span
        class="c4">refund of your Reservation Fee</span><span class="c3">.</span></p>
<hr>
<p class="c0"><span class="c3"></span></p>
<h3 class="c6" id="h.p0pxjeo0h2ff"><span class="c1">7. No Assignment or Resale</span></h3>
<p class="c2"><span class="c3">Reservations may not be transferred or resold without PakVille&rsquo;s prior written consent. Reservations suspected to be made in bad faith or for resale purposes may be cancelled at PakVille&rsquo;s discretion.</span>
</p>
<p class="c2"><span class="c3">PakVille reserves the right to verify your identity or request documentation at any time to ensure compliance with the terms of this Agreement.</span>
</p>
<hr>
<p class="c0"><span class="c3"></span></p>
<h3 class="c6" id="h.9jyutwxtu7x"><span class="c1">8. Governing Law</span></h3>
<p class="c2"><span>This Agreement is governed by the laws of the </span><span
        class="c4">Province of Quebec</span><span>&nbsp;and the </span><span
        class="c4">federal laws of Canada</span><span class="c3">&nbsp;applicable therein.</span></p>
<hr>
<p class="c0"><span class="c3"></span></p>
<h3 class="c6" id="h.7sis55tw2ovw"><span class="c1">9. Dispute Resolution</span></h3>
<p class="c2">
    <span>If you have a dispute related to your Reservation or this Agreement, please contact us at </span><span
        class="c4"><a class="c7" href="mailto:info@pakville.ca">info@pakville.ca</a></span><span class="c3">. We will work with you in good faith to resolve the issue efficiently.</span>
</p>
<hr>
<p class="c0"><span class="c3"></span></p>
<h3 class="c6" id="h.p9soz8toel6y"><span class="c1">10. Class Action and Jury Trial Waivers</span></h3>
<p class="c2"><span class="c4">To the extent permitted by law and excluding residents of Quebec</span><span class="c3">, you agree not to pursue any claims under this Agreement as part of a class action or jury trial. Disputes will be resolved individually before a court of competent jurisdiction.</span>
</p>
<hr>
<p class="c0"><span class="c3"></span></p>
<h3 class="c6" id="h.xwej0atckwwd"><span class="c1">11. Effective Date</span></h3>
<p class="c2"><span class="c3">This Agreement becomes effective upon PakVille&rsquo;s receipt of your Reservation Fee and your electronic acceptance via our website.</span>
</p>
</body>
</html>

`;